module.exports = __webpack_public_path__ + "static/media/Banner-Option2.5c35e3bf.png";